module.exports = __webpack_public_path__ + "img/s13.c547836.png";